module.exports = __webpack_public_path__ + "static/customer-notifications-mobile-c90658fa6dc7cce4a14add7b2a773c17.jpg";